module.exports = __webpack_public_path__ + "img/IMG_2671_L_Wood.8a661d73.jpg";